export function filterOutUndefinedObjectFields<T>(object: T): T {
  return (Object.keys(object) as Array<keyof T>)
    .reduce((result: T, key: keyof T): T => {
      if (object[key]) {
        result[key] = object[key];
      }
      return result;
    }, {} as T);
}
